import React from 'react';
import FavoriteShopCTA, { FavoriteShopCTAFragment } from './favorite_shop_cta';
import experiments from '@reverbdotcom/commons/src/experiments';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ShopHeaderFragment } from '@reverbdotcom/discovery-ui/src/components/discovery/shops/shop_header';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { RCBanner } from '@reverbdotcom/cadence/components';
import { get } from 'lodash';
import I18n from 'i18n-js';
import { CorePostPurchaseShopNudge } from '@reverbdotcom/commons/src/rql';
import { ChildProps } from 'react-apollo';
import { IUserContext, withUserContext } from '@reverbdotcom/commons';
import { RCAvatar } from '@reverbdotcom/cadence/components/RCAvatar/RCAvatar';

interface ExternalProps {
  shopId: string;
  orderBundleId: string;
}

type Props = ChildProps<IUserContext & ExternalProps, CorePostPurchaseShopNudge.Query, CorePostPurchaseShopNudge.Variables>;

export function PostPurchaseShopNudge(props: Props) {
  const user = props.user;
  const experiment = experiments.POST_PURCHASE_SHOP_NUDGE;
  const eligible = !props.data?.loading && !props.data.findFavorite.isFavorite;

  useViewTracking({
    componentName: 'PostPurchaseShopNudge',
    eventName: MParticleEventName.ComponentView,
    shopId: props.shopId,
    orderBundleId: props.orderBundleId,
    experiments: formatExperimentsForEventAttributes(user, [experiment]),
  }, eligible);

  if (!isExperimentEnabled(user, experiment) || !eligible) {
    return null;
  }

  return (
    <div className="post_purchase_shop_nudge--wrapper mb-2">
      <RCBanner
        title={I18n.t('discovery.checkout.postPurchaseShopNudge.title', { shop: props.data.shop.name })}
        content={I18n.t('discovery.checkout.postPurchaseShopNudge.subtitle')}
        image={
          <RCAvatar
            thumbnailURL={get(props.data.shop, 'user.avatar.source', null)}
            thumbnailFallback="shop"
            userName={props.data.shop.name}
          />
        }
        disableTexture= {true}
        theme="plain"
        mobileLayout="card"
        cta={<FavoriteShopCTA
          shop={props.data.shop}
          initialFavoriteId={null}
          theme="primary"
          parentComponentName= "PostPurchaseShopNudge"/>}
      />
    </div>
  );
}

const connect = withGraphql<Props>(
  gql`
    query Core_Post_Purchase_Shop_Nudge(
      $shop: String
    ) {
      shop(input: { id: $shop }) {
        _id
        ... ShopHeaderFragment
        ... FavoriteShopCTAData
      }
      findFavorite(
        input: {
          shopId: $shop
        }
      ) {
        isFavorite
        canFavorite
      }
    }
    ${ShopHeaderFragment}
    ${FavoriteShopCTAFragment}
  `,
  {
    options: (props) => ({
      ssr: true,
      skip: !isExperimentEnabled(props.user, experiments.POST_PURCHASE_SHOP_NUDGE),
      variables: {
        shop: props.shopId,
      },
    }),
  },
);

export default withUserContext<Props>(connect(PostPurchaseShopNudge));
